export default Object.freeze({
    VIEW: "View",
    USE: "Use",
    MODIFY: "Modify",
    DELETE: "Delete",
    CREATE: "Create",
  });